import {
  DEFAULT_CALLSHEET_DOC_TYPE,
  DEFAULT_SCRIPT_KIND,
  isCallsheetDocType,
  isScriptKind,
} from '../../shared/artifactTypes';

export function readRememberedArtifactType(tool: 'script' | 'callsheet' | 'review'): string | null {
  if (tool === 'review') return null;
  try {
    const saved = localStorage.getItem(`ss-os-artifact-kind:${tool}`);
    if (tool === 'script' && isScriptKind(saved)) return saved;
    if (tool === 'callsheet' && isCallsheetDocType(saved)) return saved;
  } catch {
    // Storage may be unavailable; creation still works with the default.
  }
  return null;
}

export function readArtifactType(tool: 'script' | 'callsheet' | 'review'): string {
  if (tool === 'review') return '';
  return readRememberedArtifactType(tool)
    ?? (tool === 'script' ? DEFAULT_SCRIPT_KIND : DEFAULT_CALLSHEET_DOC_TYPE);
}

/** Record the type only after creation succeeds, never while choosing it. */
export function rememberArtifactType(tool: 'script' | 'callsheet', value: string): void {
  try {
    localStorage.setItem(`ss-os-artifact-kind:${tool}`, value);
  } catch {
    // Remembering a preference must never prevent creation.
  }
}
